module.exports = __webpack_public_path__ + "img/chevron-upx2.155afad3.svg";